import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { FixtureViewType } from '@cds/betting-offer';
import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-pair-game-no-scoreboard',
    templateUrl: 'pair-game-no-scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AutomationModule],
})
export class PairGameNoScoreboardComponent implements OnChanges {
    @Input() event: EventModel;
    awayIndicator: string;

    constructor(public sitecore: Sitecore) {}

    ngOnChanges(): void {
        this.awayIndicator = this.event.viewType === FixtureViewType.American ? this.sitecore.globalMessages.AwayIndicator : '-';
    }
}
